import moment from 'moment'
import React from 'react'
import {useAsync} from 'react-use'
import Text from 'react-text'
import {Consumer} from '../../context'
import {requestPDF} from '../../helpers/command'
import Group from './group'
import {planningFilename} from 'components/standards-selector/domain/planning-filename.cjs'
import {parseContext} from '../planning/pdf/plan'
import DownloadLink, {PDFDocument} from '../planning/pdf/groups'
import Fade from '@mui/material/Fade'
import printStyle from './print-style.js'
import './index.styl'

function SavePDF (props) {

  const {context, author, range, title} = props
  const [groupMap, setGroupMap] = React.useState(undefined)

  React.useEffect(() => {
    setGroupMap(
      context.pdfPlans.reduce((acc, plan) => {
           const id = plan.clique || 'all'
           const plans = acc[id] = acc[id] || []
           const parsedPlan = parseContext(context, plan)
           plans.push(parsedPlan)
           return acc
      }, {})
    )
  }, [])

  return (
    <div className="save">
      {groupMap && <DownloadLink
            className="button"
            fileName={props.filename}
            groupMap={groupMap}
            author={props.author}
            range ={props.range}
            document={<PDFDocument {...{groupMap, author, range, title}} />}

          >
            {context.translate("download-planning")}
          </DownloadLink>
      }
    </div>
  )
}

export default function PlanningPdf() {
  return (<Consumer>{context => {

    const {query, profile, pdfPlans, translate} = context
    const {first_name, last_name} = profile.individual
    const {project, startDate, endDate} = profile.institution
    const {start = startDate, end = endDate} = query
    const format = date => moment(date).format('MM/DD/YYYY')
    const author = {name: first_name, lastName: last_name}
    const range =  `${format(start)} - ${format(end)}`
    const filename = planningFilename([translate('planning'), first_name, last_name])

    const title = `${translate(`${project}_project_title`)} - ${translate("planning_title")}`

    const groupMap = pdfPlans.reduce((acc, plan) => {
      const id = plan.clique || 'all'
      const plans = acc[id] = acc[id] || []
      plans.push(plan)
      return acc
    }, {})

    const groups = Object.entries(groupMap).map(([key, plans]) => <Group key={key} id={key} plans={plans} />)

    const pdfDataReady = context.pdfPlansLoaded && context.teacherExpectationsLoaded && context.teacherStandardsLoaded && context.grades.length > 1 && context.subjects.length > 1 && context.groups.length > 1
    return (
      <div className="pdfWrapper">
        <div className="pdfHtml">
          <div className="header">
            <div className="title">
              {title}
            </div>
            {/* <Fade in={pdfDataReady}> */}
              <div className="save">
                {pdfDataReady && <SavePDF {...{context, filename, author, range, title}} />}
              </div>
            {/* </Fade> */}
            <div className="date">
              <div className="generated">
                <label><Text id="generated" />:</label>
                <span>{format()}</span>
              </div>
              <div className="date-range">
                <label><Text id="date-range" />:</label>
                <span>{range}</span>
              </div>
            </div>
          </div>
          <div className="groups">
            {groups}
          </div>
        </div>
      </div>
    )
  }}</Consumer>)
}
